module.exports = __webpack_public_path__ + "static/img/2en.bf95949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/2en.png
// module id = 6z+O
// module chunks = 0